<script setup>
import { BModal,BRow, BCol, BFormInput,BButton, BFormSelect } from 'bootstrap-vue-next';
import { defineProps } from 'vue';
import { ref } from 'vue'

defineProps({
    modal: Boolean,
    updateModal: Function
})

const optionDefault =ref('admin_backoffice')

const optionsField =     [
  {value: 'housekeeping', text: 'House Keeping'},
  {value: 'supervisor', text: 'Supervisor'},
  {value: 'guide', text: 'Guide'},
  {value: 'driver', text: 'Driver'},
  
]



const prefixOptionsField =[
    {value: 'Mr.', text: 'Mr.'},
    {value: 'Mrs.', text: 'Mrs.'},
  
]

</script>

<template>
    <BModal :model-value="modal" scrollable centered >
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Add Admin</h5>
                
            </div>
            <BButton
                variant="link"
                class="close"
                @click="$emit('updateModal', false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <div class="">
            <BContainer>
                <BRow >
                    <BCol cols="3">
                        <BFormSelect id="input-1" v-model="prefix" :state="state" :options="prefixOptionsField" class="form-control"/>
                    </BCol>
                    <BCol cols="9">
                        <BFormInput id="input-1" v-model="name" :state="state" placeholder="Name" class="form-group" />
                    </BCol>
                </BRow>
                <BRow >
                    <BCol>
                        <BFormInput id="input-1" v-model="email" :state="state" placeholder="Email" class="form-group" />
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormInput id="input-1" v-model="password" :state="state" trim placeholder="Password" class="form-group"/>
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormInput id="input-1" v-model="password" :state="state" trim placeholder="Konfirmasi Password" class="form-group" />
                    </BCol>
                </BRow>
                <BRow>
                    <BCol>
                        <BFormSelect id="input-1" v-model="optionDefault" :options="optionsField" class="form-control" />
                    </BCol>
                </BRow>
            </BContainer>
            
                
        
        </div>
    </BModal>
</template>

